// Generated by purs version 0.14.4
import * as Algorithm_NaturalSort from "../Algorithm.NaturalSort/index.js";
import * as Control_Alternative from "../Control.Alternative/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Replace from "../Control.Monad.Replace/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_FoldableWithIndex from "../Data.FoldableWithIndex/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Invariant from "../Data.Functor.Invariant/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Dom_Widgets_Input from "../Specular.Dom.Widgets.Input/index.js";
import * as Specular_Extra_Switch from "../Specular.Extra.Switch/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
var OptGroup = (function () {
    function OptGroup(value0) {
        this.value0 = value0;
    };
    OptGroup.create = function (value0) {
        return new OptGroup(value0);
    };
    return OptGroup;
})();
var SingleOption = (function () {
    function SingleOption(value0) {
        this.value0 = value0;
    };
    SingleOption.create = function (value0) {
        return new SingleOption(value0);
    };
    return SingleOption;
})();
var select = function (dictEq) {
    return function (props) {
        return function (options) {
            return function (ref) {
                var valueRef = Specular_Extra_Switch["switch"](Specular_Extra_Switch.switchRef)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v) {
                    var findOptionValue = function (k) {
                        return Data_Array.findMapWithIndex(function (groupIndex) {
                            return function (v1) {
                                if (v1 instanceof OptGroup) {
                                    return Data_Functor.map(Data_Maybe.functorMaybe)(function (v2) {
                                        return Data_Show.show(Data_Show.showInt)(groupIndex) + ("/" + Data_Show.show(Data_Show.showInt)(v2));
                                    })(Data_Array.findIndex(function (option) {
                                        return Data_Eq.eq(dictEq)(Data_Record.getField(Data_Record.hasFieldRecord({
                                            reflectSymbol: function () {
                                                return "key";
                                            }
                                        })())(Data_Symbol.SProxy.value)(option))(k);
                                    })(Data_Record.getField(Data_Record.hasFieldRecord({
                                        reflectSymbol: function () {
                                            return "options";
                                        }
                                    })())(Data_Symbol.SProxy.value)(v1.value0)));
                                };
                                if (v1 instanceof SingleOption) {
                                    var $45 = Data_Eq.eq(dictEq)(Data_Record.getField(Data_Record.hasFieldRecord({
                                        reflectSymbol: function () {
                                            return "key";
                                        }
                                    })())(Data_Symbol.SProxy.value)(v1.value0))(k);
                                    if ($45) {
                                        return new Data_Maybe.Just(Data_Show.show(Data_Show.showInt)(groupIndex));
                                    };
                                    return Data_Maybe.Nothing.value;
                                };
                                throw new Error("Failed pattern match at Specular.Select (line 83, column 17 - line 88, column 80): " + [ v1.constructor.name ]);
                            };
                        })(v);
                    };
                    var findKey = function (indexStr) {
                        var v1 = function (v2) {
                            var v3 = function (v4) {
                                if (Data_Boolean.otherwise) {
                                    return Data_Maybe.Nothing.value;
                                };
                                throw new Error("Failed pattern match at Specular.Select (line 75, column 1 - line 75, column 106): " + [ indexStr.constructor.name ]);
                            };
                            var $49 = Data_String_Common.split("/")(indexStr);
                            if ($49.length === 2) {
                                var $50 = Data_Int.fromString($49[0]);
                                if ($50 instanceof Data_Maybe.Just) {
                                    var $51 = Data_Int.fromString($49[1]);
                                    if ($51 instanceof Data_Maybe.Just) {
                                        var $52 = Data_Array.index(v)($50.value0);
                                        if ($52 instanceof Data_Maybe.Just && $52.value0 instanceof OptGroup) {
                                            var $53 = Data_Array.index(Data_Record.getField(Data_Record.hasFieldRecord({
                                                reflectSymbol: function () {
                                                    return "options";
                                                }
                                            })())(Data_Symbol.SProxy.value)($52.value0.value0))($51.value0);
                                            if ($53 instanceof Data_Maybe.Just) {
                                                return new Data_Maybe.Just(Data_Record.getField(Data_Record.hasFieldRecord({
                                                    reflectSymbol: function () {
                                                        return "key";
                                                    }
                                                })())(Data_Symbol.SProxy.value)($53.value0));
                                            };
                                            return v3(true);
                                        };
                                        return v3(true);
                                    };
                                    return v3(true);
                                };
                                return v3(true);
                            };
                            return v3(true);
                        };
                        var $62 = Data_Int.fromString(indexStr);
                        if ($62 instanceof Data_Maybe.Just) {
                            var $63 = Data_Array.index(v)($62.value0);
                            if ($63 instanceof Data_Maybe.Just && $63.value0 instanceof SingleOption) {
                                return new Data_Maybe.Just(Data_Record.getField(Data_Record.hasFieldRecord({
                                    reflectSymbol: function () {
                                        return "key";
                                    }
                                })())(Data_Symbol.SProxy.value)($63.value0.value0));
                            };
                            return v1(true);
                        };
                        return v1(true);
                    };
                    return Data_Functor_Invariant.imap(Specular_Ref.invariantRef)(function (k) {
                        return Data_Maybe.fromMaybe("")(Control_Bind.bind(Data_Maybe.bindMaybe)(k)(findOptionValue));
                    })(findKey)(ref);
                })(options));
                return Specular_Dom_Element.el("select")([ Data_Foldable.fold(Data_Foldable.foldableArray)(Specular_Dom_Element.monoidProp)(props), Specular_Dom_Element.bindValueOnChange(valueRef) ])(Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Builder.getParentNode)(function (node) {
                    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Control_Monad_Replace.newSlot(Specular_Dom_Builder.monadReplaceBuilder))(function (slot) {
                        return Data_Function.flip(Specular_FRP_Base.subscribeDyn_(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder)))(options)(function (options$prime) {
                            return function __do() {
                                Control_Monad_Replace.replaceSlot(slot)(Data_FoldableWithIndex.forWithIndex_(Specular_Dom_Builder.applicativeBuilder)(Data_FoldableWithIndex.foldableWithIndexArray)(options$prime)(function (indexOutsideGroup) {
                                    return function (opt) {
                                        if (opt instanceof OptGroup) {
                                            return Specular_Dom_Element.el("optgroup")([ Specular_Dom_Element.attr("label")(Data_Record.getField(Data_Record.hasFieldRecord({
                                                reflectSymbol: function () {
                                                    return "label";
                                                }
                                            })())(Data_Symbol.SProxy.value)(opt.value0)), Specular_Dom_Element.attrWhen(Data_Record.getField(Data_Record.hasFieldRecord({
                                                reflectSymbol: function () {
                                                    return "disabled";
                                                }
                                            })())(Data_Symbol.SProxy.value)(opt.value0))("disabled")("disabled") ])(Data_FoldableWithIndex.forWithIndex_(Specular_Dom_Builder.applicativeBuilder)(Data_FoldableWithIndex.foldableWithIndexArray)(Data_Record.getField(Data_Record.hasFieldRecord({
                                                reflectSymbol: function () {
                                                    return "options";
                                                }
                                            })())(Data_Symbol.SProxy.value)(opt.value0))(function (indexInsideGroup) {
                                                return function (option) {
                                                    return Specular_Dom_Element.el("option")([ Specular_Dom_Element.attrWhen(Data_Record.getField(Data_Record.hasFieldRecord({
                                                        reflectSymbol: function () {
                                                            return "disabled";
                                                        }
                                                    })())(Data_Symbol.SProxy.value)(option))("disabled")("disabled"), Specular_Dom_Element.attr("value")(Data_Show.show(Data_Show.showInt)(indexOutsideGroup) + ("/" + Data_Show.show(Data_Show.showInt)(indexInsideGroup))) ])(Specular_Dom_Element.text(Data_Record.getField(Data_Record.hasFieldRecord({
                                                        reflectSymbol: function () {
                                                            return "label";
                                                        }
                                                    })())(Data_Symbol.SProxy.value)(option)));
                                                };
                                            }));
                                        };
                                        if (opt instanceof SingleOption) {
                                            return Specular_Dom_Element.el("option")([ Specular_Dom_Element.attrWhen(Data_Record.getField(Data_Record.hasFieldRecord({
                                                reflectSymbol: function () {
                                                    return "disabled";
                                                }
                                            })())(Data_Symbol.SProxy.value)(opt.value0))("disabled")("disabled"), Specular_Dom_Element.attr("value")(Data_Show.show(Data_Show.showInt)(indexOutsideGroup)) ])(Specular_Dom_Element.text(Data_Record.getField(Data_Record.hasFieldRecord({
                                                reflectSymbol: function () {
                                                    return "label";
                                                }
                                            })())(Data_Symbol.SProxy.value)(opt.value0)));
                                        };
                                        throw new Error("Failed pattern match at Specular.Select (line 120, column 11 - line 128, column 34): " + [ opt.constructor.name ]);
                                    };
                                }))();
                                var value = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(Specular_Ref.refValue(valueRef))();
                                return Specular_Dom_Widgets_Input.setTextInputValue(node)(value)();
                            };
                        });
                    });
                }));
            };
        };
    };
};
var optionLabel = function (v) {
    if (v instanceof OptGroup) {
        return v.value0.label;
    };
    if (v instanceof SingleOption) {
        return v.value0.label;
    };
    throw new Error("Failed pattern match at Specular.Select (line 141, column 1 - line 141, column 44): " + [ v.constructor.name ]);
};
var naturalSortByLabels = (function () {
    var sortInGroups = function (v) {
        if (v instanceof OptGroup) {
            return OptGroup.create({
                label: v.value0.label,
                disabled: v.value0.disabled,
                options: Data_Array.sortWith(Data_Ord.ordArray(Algorithm_NaturalSort.ordSortChunk))(function ($116) {
                    return Algorithm_NaturalSort.naturalKey((function (v2) {
                        return Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "label";
                            }
                        })())(Data_Symbol.SProxy.value)(v2);
                    })($116));
                })(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "options";
                    }
                })())(Data_Symbol.SProxy.value)(v.value0))
            });
        };
        if (v instanceof SingleOption) {
            return new SingleOption(v.value0);
        };
        throw new Error("Failed pattern match at Specular.Select (line 138, column 3 - line 138, column 101): " + [ v.constructor.name ]);
    };
    var $117 = Data_Functor.map(Data_Functor.functorArray)(sortInGroups);
    var $118 = Data_Array.sortWith(Data_Ord.ordArray(Algorithm_NaturalSort.ordSortChunk))(function ($120) {
        return Algorithm_NaturalSort.naturalKey(optionLabel($120));
    });
    return function ($119) {
        return $117($118($119));
    };
})();
var mapOptions = function (f) {
    return Data_Functor.map(Data_Functor.functorArray)(function (v) {
        if (v instanceof OptGroup) {
            return OptGroup.create({
                label: v.value0.label,
                disabled: v.value0.disabled,
                options: Data_Functor.map(Data_Functor.functorArray)(function (o) {
                    return {
                        key: f(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "key";
                            }
                        })())(Data_Symbol.SProxy.value)(o)),
                        disabled: o.disabled,
                        label: o.label
                    };
                })(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "options";
                    }
                })())(Data_Symbol.SProxy.value)(v.value0))
            });
        };
        if (v instanceof SingleOption) {
            return SingleOption.create({
                key: f(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "key";
                    }
                })())(Data_Symbol.SProxy.value)(v.value0)),
                label: v.value0.label,
                disabled: v.value0.disabled
            });
        };
        throw new Error("Failed pattern match at Specular.Select (line 69, column 3 - line 73, column 45): " + [ v.constructor.name ]);
    });
};
var genericOption = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new OptGroup(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new SingleOption(x.value0);
        };
        throw new Error("Failed pattern match at Specular.Select (line 26, column 1 - line 26, column 54): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof OptGroup) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof SingleOption) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Specular.Select (line 26, column 1 - line 26, column 54): " + [ x.constructor.name ]);
    }
};
var showOption = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericOption)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "disabled";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "label";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "options";
            }
        })(Data_Show.showRecordFieldsNil)(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "disabled";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "key";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "label";
            }
        })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(dictShow))(Data_Show.showBoolean)))))(Data_Show.showString))(Data_Show.showBoolean))))({
            reflectSymbol: function () {
                return "OptGroup";
            }
        }))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "disabled";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "key";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "label";
            }
        })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(dictShow))(Data_Show.showBoolean))))({
            reflectSymbol: function () {
                return "SingleOption";
            }
        })))
    };
};
var functorOption = {
    map: function (f) {
        return function (m) {
            if (m instanceof OptGroup) {
                return new OptGroup((function (o) {
                    return {
                        options: Data_Functor.map(Data_Functor.functorArray)(function (o1) {
                            return {
                                key: f(o1.key),
                                disabled: o1.disabled,
                                label: o1.label
                            };
                        })(o.options),
                        disabled: o.disabled,
                        label: o.label
                    };
                })(m.value0));
            };
            if (m instanceof SingleOption) {
                return new SingleOption((function (o) {
                    return {
                        key: f(o.key),
                        disabled: o.disabled,
                        label: o.label
                    };
                })(m.value0));
            };
            throw new Error("Failed pattern match at Specular.Select (line 24, column 1 - line 24, column 48): " + [ m.constructor.name ]);
        };
    }
};
var flattenOptionsWith = function (f) {
    return Data_Array.concatMap(function (opt) {
        if (opt instanceof SingleOption) {
            return [ f(opt.value0) ];
        };
        if (opt instanceof OptGroup) {
            return Data_Functor.map(Data_Functor.functorArray)(f)(opt.value0.options);
        };
        throw new Error("Failed pattern match at Specular.Select (line 54, column 3 - line 56, column 42): " + [ opt.constructor.name ]);
    });
};
var flattenOptions = Data_Array.concatMap(function (v) {
    if (v instanceof OptGroup && v.value0.disabled) {
        return Data_Functor.map(Data_Functor.functorArray)(function (o) {
            return {
                disabled: true,
                key: o.key,
                label: o.label
            };
        })(v.value0.options);
    };
    if (v instanceof OptGroup) {
        return v.value0.options;
    };
    if (v instanceof SingleOption) {
        return [ v.value0 ];
    };
    throw new Error("Failed pattern match at Specular.Select (line 46, column 3 - line 50, column 30): " + [ v.constructor.name ]);
});
var findOption = function (dictEq) {
    return function (k) {
        return Data_Array.findMap(function (v) {
            if (v instanceof OptGroup) {
                return Data_Array.find(function (option) {
                    return Data_Eq.eq(dictEq)(Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "key";
                        }
                    })())(Data_Symbol.SProxy.value)(option))(k);
                })(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "options";
                    }
                })())(Data_Symbol.SProxy.value)(v.value0));
            };
            if (v instanceof SingleOption) {
                var $103 = Data_Eq.eq(dictEq)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "key";
                    }
                })())(Data_Symbol.SProxy.value)(v.value0))(k);
                if ($103) {
                    return new Data_Maybe.Just(v.value0);
                };
                return Data_Maybe.Nothing.value;
            };
            throw new Error("Failed pattern match at Specular.Select (line 148, column 5 - line 152, column 58): " + [ v.constructor.name ]);
        });
    };
};
var filterOptions = function (pred) {
    return Data_Array.mapMaybe(function (v) {
        if (v instanceof SingleOption) {
            var $106 = pred(Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "key";
                }
            })())(Data_Symbol.SProxy.value)(v.value0));
            if ($106) {
                return new Data_Maybe.Just(new SingleOption(v.value0));
            };
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof OptGroup) {
            var options$prime = Data_Array.filter(function ($121) {
                return pred((function (v1) {
                    return Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "key";
                        }
                    })())(Data_Symbol.SProxy.value)(v1);
                })($121));
            })(v.value0.options);
            return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_Alternative.guard(Data_Maybe.alternativeMaybe)(!Data_Array["null"](options$prime)))(function () {
                return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(OptGroup.create({
                    label: v.value0.label,
                    disabled: v.value0.disabled,
                    options: options$prime
                }));
            });
        };
        throw new Error("Failed pattern match at Specular.Select (line 60, column 3 - line 65, column 49): " + [ v.constructor.name ]);
    });
};
var eqOption = function (dictEq) {
    return {
        eq: function (x) {
            return function (y) {
                if (x instanceof OptGroup && y instanceof OptGroup) {
                    return x.value0.disabled === y.value0.disabled && x.value0.label === y.value0.label && Data_Eq.eq(Data_Eq.eqArray(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
                        reflectSymbol: function () {
                            return "label";
                        }
                    })(Data_Eq.eqString))()({
                        reflectSymbol: function () {
                            return "key";
                        }
                    })(dictEq))()({
                        reflectSymbol: function () {
                            return "disabled";
                        }
                    })(Data_Eq.eqBoolean))))(x.value0.options)(y.value0.options);
                };
                if (x instanceof SingleOption && y instanceof SingleOption) {
                    return x.value0.disabled === y.value0.disabled && Data_Eq.eq(dictEq)(x.value0.key)(y.value0.key) && x.value0.label === y.value0.label;
                };
                return false;
            };
        }
    };
};
export {
    OptGroup,
    SingleOption,
    flattenOptions,
    flattenOptionsWith,
    filterOptions,
    mapOptions,
    select,
    naturalSortByLabels,
    optionLabel,
    findOption,
    functorOption,
    eqOption,
    genericOption,
    showOption
};
//# sourceMappingURL=index.js.map
